import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL + "/admin/ems-folders/";

const getEmsFolder = (clientId) => {
    return axios.get(API_URL + clientId, { headers: authHeader() });
};

const saveEmsFolder = (clientId, folderData) => {
    return axios.post(API_URL + clientId, folderData, { headers: authHeader() });
};

const deleteEmsFolder = (clientId) => {
    return axios.delete(API_URL + clientId, { headers: authHeader() });
};

const emsFolderService = {
    getEmsFolder,
    saveEmsFolder,
    deleteEmsFolder,
};

export default emsFolderService;
